module.exports = __webpack_public_path__ + "static/media/Informativa R.5238b54e.svg";